export const SET_ARCHIVE = 'ARCHIVE/SET_ARCHIVE'
export const SET_ARCHIVES = 'ARCHIVE/SET_ARCHIVES'
